//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import CustomAvatar from '../../../components/basic/customAvatar'

//material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core'

//style
import './AddEditVignettes.scss'

import image from '../../../assets/image/svg/logo.svg'


@inject('translate')
@inject('internal')
@observer
export default class AddEditVignettes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      data: [],
      selected: [],
      name: '',
    }
  }
  
  isEditMode = null
  
  componentDidMount() {
    
    this.isEditMode = toJS(this.props.internal.actionEdit)
    
    if (this.isEditMode.edit) {
      //load detail fixneho setu
      this.loadVignette()
    } else {
      this.setState({ loading: false })
    }
  }
  
  vignetteData = {}
  loadVignette = async () => {
    let idVignette = toJS(this.props.internal.actionEdit.id)
    
    let load_vignette = await api({
      method: 'get',
      url: `lists/vignettes/${idVignette}`,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_vignette.success) {
      this.vignetteData = load_vignette.data.data
      this.setState({
        loading: false,
        name: load_vignette.data.data.name,
      })
    }
  }
  
  action = () => {
    let isEdit = toJS(this.props.internal.actionEdit.edit)
    this.setState({ loadingBtn: true })
    if (isEdit) {
      //update
      this.updateVignette()
    } else {
      //create
      this.createVignette()
    }
  }
  
  updateVignette = async () => {
    let name = this.name.state.value
    if (name !== '') {
      let idVignette = toJS(this.props.internal.actionEdit.id)
      
      let update_data = await api({
        method: 'patch',
        url: `lists/vignettes/${idVignette}`,
        authorization: this.props.internal.user.access_token,
        params: {
          name: name,
        },
      })
      
      if (update_data.success === true) {
          this.props.internal.setSnackbar(update_data.data.message, true)
          this.setState({ loadingBtn: false })
          this.props.onClose(true)
      } else {
        if (update_data.data.data.hasOwnProperty('errors')) {
          const firstKey = Object.keys(update_data.data.data.errors).shift()
          this.props.internal.setSnackbar(update_data.data.data.errors[firstKey][0], true)
        } else {
          this.props.internal.setSnackbar(update_data.data.message, true)
        }
        this.setState({ loadingBtn: false })
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }
    
  }
  
  createVignette = async () => {
    let name = this.name.state.value
    if (name !== '') {
      this.setState({ loadingBtn: true })
      let update_data = await api({
        method: 'post',
        url: `lists/vignettes`,
        authorization: this.props.internal.user.access_token,
        params: {
          name: name,
        },
      })
      
      if (update_data.success === true || (update_data.success === false && update_data.status === 201)) {
        this.props.internal.setSnackbar(update_data.data.message, true)
        this.setState({ loadingBtn: false })
        this.props.onClose(true)
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }
    
  }
  
  handleChangePhoto = async (data) => {
    let isVignette = toJS(this.props.internal.actionEdit.id)
    
    if (isVignette !== null) {
      this.setState({ loadingBtn: true })
      let upload_data = await api({
        method: 'post',
        url: `lists/vignettes/${isVignette}`,
        formData: true,
        authorization: this.props.internal.user.access_token,
        params: {
          image: data,
        },
        
      })
      
      if (upload_data.success && upload_data.success === true) {
        // this.props.internal.photoWasChanged(false)
        this.props.internal.setSnackbar(upload_data.data.message, true)
        this.setState({ loadingBtn: false })
        return Promise.resolve(false)
      } else {
        this.props.internal.setSnackbar(upload_data.data.message, true)
      }
    } else {
    
    }
  }
  
  editCategory = {}
  
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={() => this.props.onClose(false)}
        aria-labelledby="form-dialog-title"
        scroll={'body'}
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        {this.state.loading
          ?
          <div style={{ minHeight: '100px' }}>
            <CircularProgress className={'circular-progress'}/>
          </div>
          :
          <DialogContent>
            {this.isEditMode && this.isEditMode.edit && (<div className={'justify-center'}>
              <CustomAvatar
                src={this.vignetteData.asset_image ? this.vignetteData.asset_image : image}
                actionUploadPhoto={this.handleChangePhoto}
              />
              <div style={{margin: '5px 0 10px'}}><em><small>{this.props.translate.i18n.MODULES.VIGNETTES.IMAGE_UPDATE_INFO}</small></em></div>
            </div>)}
            <CustomInput
              ref={ref => this.name = ref}
              text={this.props.translate.i18n.MODULES['FIXED-SETS'].TITLE}
              value={this.state.name}
              id={'title'}
              className={'w-100'}
              required
            />
          </DialogContent>
        }
        <DialogActions>
          <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          </Button>
          <CustomButton
            progressBar={this.state.loadingBtn}
            onClick={this.action}
            mystyle={'btn-white-bg'}
            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            justText
            disabled={this.state.loading}
          />
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/Vignettes/AddEdit/AddEditVignettes.js